export const typography = {
  body: "Quicksand, monospace",
  heading: "Quicksand, monospace",
  primary: "Quicksand",
};
